import { t } from 'i18next'
import { z } from 'zod'

import { applicableDomains } from 'features/globalSetup/types/filteringRule'

export const commonSchema = z
  .object({
    applicableDomains: z.enum(applicableDomains),
    blocked: z.array(z.string().min(1)),
    domainIds: z.array(z.string()),
    name: z.string().min(1),
  })
  .superRefine((data, ctx): void => {
    const hasEmptyChip: boolean = data.blocked.some(
      (blockedValue: string): boolean => blockedValue.trim().length === 0,
    )

    if (data.blocked.length === 0 || hasEmptyChip) {
      ctx.addIssue({
        code: 'custom',
        message: t('features/globalSetup:prebid.protection.form.blocked.emptyMessage'),
        path: ['blocked'],
      })
    }
  })

export type CommonSchema = z.infer<typeof commonSchema>
